import { createEvent, createStore, Store } from 'effector';
import { effectorStartEvent } from '@nx-frontend/shared/store/client-side';

const STORAGE_KEY = 'portal-user-values';

interface PortalUserValuesState {
  processViewIntroShowed: boolean;
  integrationsIntroShowed: boolean;
}

const defaultState: PortalUserValuesState = {
  processViewIntroShowed: false,
  integrationsIntroShowed: false,
};

const getInitialState = (): PortalUserValuesState => {
  if (typeof window === 'undefined') {
    return defaultState;
  }
  try {
    const storedState = localStorage.getItem(STORAGE_KEY);
    return { ...defaultState, ...(storedState != null ? JSON.parse(storedState) : null) };
  } catch {
    return defaultState;
  }
};

export const updatePortalUserValuesEvent = createEvent<Partial<PortalUserValuesState>>();

export const $portalUserValues: Store<PortalUserValuesState> = createStore(getInitialState())
  .on(effectorStartEvent, (state) => state)
  .on(updatePortalUserValuesEvent, (state, update) => {
    const newState = { ...state, ...update };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
    return newState;
  });
